<template>
  <b-modal ref="modal" title="پیوست سفارش" size="md" ok-only ok-title="تایید" @ok="onOk">
    <div class="card">
      <div class="card-body">
        <div class="row mb-2">
          <div class="input-group col-sm-7">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>سلام</span>
              </div>
            </div>
            <input v-model="model.productName"  type="text" class="form-control" readonly="readonly">
          </div>
          <div class="input-group col-sm-5">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>سلام</span>
              </div>
            </div>
            <input v-model="unit"  type="text" class="form-control" readonly="readonly">
          </div>
        </div>
        <div class="row mb-2">
          <div class="input-group col-sm-7">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <i class="icon-calendar-blank-outline"></i>
                <span>تاریخ تحویل</span>
              </div>
            </div>
            <date-picker v-if="mode!=='view'" format="jYYYY-jMM-jDD" @input="setDateFromDatePicker" ref="datePicker" :auto-submit="true">
              <slot>
                <input v-model="deliveryDate" class="form-control date-input" @focus="toggleDatePicker" @click="toggleDatePicker" readonly placeholder="کلیک کنید">
              </slot>
            </date-picker>
            <input v-if="mode==='view'" v-model="deliveryDate" type="text" class="form-control" readonly>
          </div>
          <div class="input-group col-sm-5">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تعداد</span>
              </div>
            </div>
            <input ref="defaultInput" v-model="model.number" type="text" class="form-control" @change="onChangeData" :readonly="mode==='view'">
          </div>
        </div>
        <div class="row">
          <div class="input-group col-sm-12">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>شرح</span>
              </div>
            </div>
            <input v-model="model.description" type="text" class="form-control" @change="onChangeData" :readonly="mode==='view'">
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
  import Moment from "moment-jalali";
  import DatePicker from "./vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  export default {
    props: {
      product: {},
      model: {
        default() {
          return {
            price: 0,
            number: 0,
            description: "",
            mode: "view"
          };
        },
        type: Object
      }
    },
    data() {
      return {
        unit: null,
        deliveryDate: null,
        mode: "view",
        date: null
      };
    },
    components: {
      datePicker: DatePicker
    },
    methods: {
      setDateFromDatePicker(date) {
        this.deliveryDate = date;
        this.model.deliveryDate = date;
      },
      toggleDatePicker() {
        if (this.mode === "view") {
          return;
        }
        this.$refs.datePicker.togglePicker();
      },
      onOk() {
        if (this.mode === "view") {
          return;
        }
        if (this.mode === "edit") {
          this.$emit("onProductOrderModalOk", "update");
          return;
        }
        this.$emit("onProductOrderModalOk", "create");
      },
      openModal() {
        this.$refs.modal.show();
      },
      onChangeData() {
        this.$emit("changepoData", this.model);
      }
    },
    mounted() {
      setTimeout(() => {
        // this.$refs.defaultInput.focus();
      }, 500);
      console.log(this.model);
      if (this.model) {
        this.mode = this.model.mode;
        this.unit = this.model.unit;
        this.deliveryDate = this.model.deliveryDate && this.model.deliveryDate.substring(0, 10);
      }
    },
    beforeUpdate() {}
  };
</script>
<style scoped>
  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }

</style>
